module.exports = __webpack_public_path__ + "static/media/Bytt-tutorial-3.1ae552ae.mp3";